import React, { Component } from 'react';
import { flow } from 'lodash';
import PropTypes from 'prop-types';
import { TimelineLite } from 'gsap';
import withSlide from '../Slide';

class TwoColumnReveal extends Component {
  constructor(props) {
    super(props);

    this.imgWrapperElements = [];
  }

  componentDidMount() {
    this.timeline = new TimelineLite({
      paused: true
    });

    const autoArrivalDelay = 5;
    const autoTransitionDuration = 2;

    this.props.images.forEach((img, index) => {
      const transitionDuration =
        typeof img.transitionDuration === 'number'
          ? img.transitionDuration
          : autoTransitionDuration;
      const arrivalTime =
        typeof img.arrivalTime === 'number'
          ? img.arrivalTime
          : autoArrivalDelay * index;

      if (img.transition === 'fade') {
        this.timeline.fromTo(
          this.imgWrapperElements[index],
          transitionDuration,
          { opacity: 0 },
          { opacity: 1 },
          arrivalTime
        );
      } else if (img.transition === 'descend') {
        this.timeline.fromTo(
          this.imgWrapperElements[index],
          transitionDuration,
          { yPercent: -100 },
          { yPercent: 0 },
          arrivalTime
        );
      } else {
        this.timeline.to(
          this.imgWrapperElements[index],
          0,
          { visibility: 'hidden' },
          0
        );
        this.timeline.to(
          this.imgWrapperElements[index],
          0,
          { visibility: 'visible' },
          arrivalTime
        );
      }
    });

    this.props.setGreensockObjectFunc(this.timeline);
  }

  setRef = element => {
    // this callback is activated on unmount for some reason, so gotta make sure we're receiving a real element
    if (element) {
      const index = element.attributes.index.value;
      this.imgWrapperElements[index] = element;
    }
  };

  render() {
    return (
      <div className={this.props.classNameFunc('TwoColumnReveal')}>
        <div className="slide__content__animation-type--TwoColumnReveal__min-height-clamp" />
        <div className="slide__content__animation-type--TwoColumnReveal__wrapper">
          {this.props.images.map((img, index) => {
            return (
              <div
                className="slide__content__animation-type--TwoColumnReveal__wrapper__img-wrapper"
                key={index}
                index={index}
                ref={this.setRef}
              >
                <img
                  alt={img.alt}
                  className="slide__content__animation-type--TwoColumnReveal__wrapper__img-wrapper__img"
                  height="263"
                  src={img.src}
                  width="300"
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

TwoColumnReveal.propTypes = {
  classNameFunc: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(
    // TODO: custom validator to ensure there are exactly two images
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      transition: PropTypes.string,
      transitionDuration: PropTypes.number
    })
  ),
  paused: PropTypes.bool.isRequired
};

export default flow(withSlide)(TwoColumnReveal);



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/slideTypes/TwoColumnReveal.js